import { clsCat, cn } from '@/styles/styles.utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { Loader } from 'lucide-react';
import { type HTMLAttributes } from 'react';

const loadingVariants = cva(
  clsCat({
    base: 'animate-spin',
  }),
  {
    variants: {
      size: {
        small: 'h-6 w-6',
        large: 'my-[20vh] h-10 w-10',
      },
    },
  }
);

type loadingProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof loadingVariants> & {
    size?: 'small' | 'large';
    inline?: boolean;
    color?: string;
  };

export const Loading = ({ size = 'large', inline = false, color = '#000' }: loadingProps) => {
  const width = size === 'small' ? 'w-6' : 'w-10';
  return (
    <div className={cn('flex h-full items-center justify-center', inline && `inline ${width}`)}>
      <div className={cn(loadingVariants({ size }))} aria-label="Loading content...">
        <Loader className={cn('h-full w-full')} color={color} />
      </div>
    </div>
  );
};
